import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HhsgSharedCorporation } from "../models/corporation.model";
import { HhsgSharedConfigService } from "./config.service";
import { HhsgSharedHttpService } from "./http.service";

@Injectable()
export class HhsgSharedCorporationService {
    private readonly _apiServer: string;
    private readonly _controllerName = 'Corporations';

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.stsServer;
    }

    public async getAllActiveCorporations(): Promise<HhsgSharedCorporation[]> {
		const params = new HttpParams({
			fromObject: {
				includeInactive: 'false'
			}
		});

		return this._httpService.doGetRequestWithParamsAsync<HhsgSharedCorporation[]>(this._apiServer, this._controllerName, 'GetCorporationsForUser', params);
	}

    public async getAllCorporations(): Promise<HhsgSharedCorporation[]> {
		const params = new HttpParams({
			fromObject: {
				includeInactive: 'true'
			}
		});

		return this._httpService.doGetRequestWithParamsAsync<HhsgSharedCorporation[]>(this._apiServer, this._controllerName, 'GetCorporationsForUser', params);
	}
}